import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':jobId'}/jobTrackingTemplateColumns`;

export const ROUTE: RouteDefinition = `${baseRoute}/:jobId/jobTrackingTemplateColumns`;

export const URL = (jobId: number): RouteDefinition =>
	`${baseRoute}/${jobId}/jobTrackingTemplateColumns`;
